import React, { useImperativeHandle, useRef } from 'react';
import { QRCode } from 'react-qrcode-logo';
import './styles.scss';

const QRCodeComponent = React.forwardRef(({ content, size = 200, id = "_maneje", hasButtonDownload = false }, ref) => {
  const qrCodeRef = useRef();

  // Expor o ref do componente filho para o pai
  useImperativeHandle(ref, () => ({
    getQRCode: () => {
      return qrCodeRef.current;
    }
  }));

  const handleDownload = () => {
		qrCodeRef.current?.download()
	}

  return (
    <div className="qr-code__container">
    <QRCode
      ref={qrCodeRef}
      id={`QRCode${id}`}
      value={content}
      fgColor='#0b7348'
      size={size}
      eyeRadius={16}
    />
    {hasButtonDownload && <><span
      className="download_qr"
      onClick={handleDownload}
    >
      <span>Baixar QR Code</span>
    </span></>}
  </div>
  );
});

export default QRCodeComponent;